export default function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}



// WEBPACK FOOTER //
// ./app/utils/numeric/isNumber.js